import _defineProperty from "/home/runner/work/website/website/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { Fragment, useMemo, createElement } from 'react';
import { useHTMLProps } from '../html/use-props.mjs';
import { filterProps } from './utils/filter-props.mjs';
import { isSVGComponent } from './utils/is-svg-component.mjs';
import { useSVGProps } from '../svg/use-props.mjs';
import { isMotionValue } from '../../value/utils/is-motion-value.mjs';
function createUseRender() {
  var forwardMotionProps = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
  var useRender = function useRender(Component, props, ref, _ref, isStatic) {
    var latestValues = _ref.latestValues;
    var useVisualProps = isSVGComponent(Component) ? useSVGProps : useHTMLProps;
    var visualProps = useVisualProps(props, latestValues, isStatic, Component);
    var filteredProps = filterProps(props, typeof Component === "string", forwardMotionProps);
    var elementProps = Component !== Fragment ? _objectSpread(_objectSpread(_objectSpread({}, filteredProps), visualProps), {}, {
      ref: ref
    }) : {};
    /**
     * If component has been handed a motion value as its child,
     * memoise its initial value and render that. Subsequent updates
     * will be handled by the onChange handler
     */
    var children = props.children;
    var renderedChildren = useMemo(function () {
      return isMotionValue(children) ? children.get() : children;
    }, [children]);
    return createElement(Component, _objectSpread(_objectSpread({}, elementProps), {}, {
      children: renderedChildren
    }));
  };
  return useRender;
}
export { createUseRender };